import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { formatCpf } from "./masks.js";
/**
 * O olho que mostra e esconde dado pessoal na TELA.
 *
 * Diretriz de 14/10/2026: na tela, o CPF aparece mascarado por padrao e o olho
 * tira a mascara; no relatorio (CSV, Excel) ele sai completo, cada perfil no
 * seu escopo. O olho e' conforto, nao protecao — quando ele tem o que mostrar,
 * o CPF ja' chegou ao navegador. Quem decide se o CPF completo pode chegar e' a
 * API (ex.: `cpfDaFichaVisivel` no portal do banco); sem ele, o olho fica
 * desabilitado e diz por que.
 */
export function OlhoBotao({ revelado, onAlternar, rotulo = "CPF", desabilitado, motivoDesabilitado, }) {
    const acao = revelado ? `Ocultar ${rotulo}` : `Mostrar ${rotulo}`;
    return (_jsx("button", { type: "button", onClick: onAlternar, disabled: desabilitado, "aria-pressed": revelado, "aria-label": acao, title: desabilitado ? (motivoDesabilitado ?? `${rotulo} completo indisponível`) : acao, style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 26,
            height: 26,
            padding: 0,
            borderRadius: 6,
            border: "1px solid var(--border-strong)",
            background: "transparent",
            color: "var(--text-muted)",
            cursor: desabilitado ? "not-allowed" : "pointer",
            opacity: desabilitado ? 0.45 : 1,
            verticalAlign: "middle",
        }, children: _jsx(Olho, { fechado: !revelado }) }));
}
/**
 * CPF mascarado com o olho ao lado.
 *
 * Controlado (`revelado` vindo de fora) quando uma tabela inteira obedece a UM
 * olho no topo — ai a linha nao desenha botao proprio. Sem `revelado`, cada
 * instancia tem o seu.
 */
export function CpfRevelavel({ cpf, cpfMasked, revelado: controlado, motivoSemCpf, }) {
    const [proprio, setProprio] = useState(false);
    const temCpf = !!cpf && cpf.replace(/\D/g, "").length === 11;
    const revelado = (controlado ?? proprio) && temCpf;
    const texto = revelado ? formatCpf(cpf) : cpfMasked || "—";
    return (_jsxs("span", { style: { display: "inline-flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }, children: [_jsx("span", { style: { fontFamily: "var(--font-mono)" }, children: texto }), controlado === undefined ? (_jsx(OlhoBotao, { revelado: revelado, onAlternar: () => setProprio((v) => !v), desabilitado: !temCpf, motivoDesabilitado: motivoSemCpf })) : null] }));
}
function Olho({ fechado }) {
    return (_jsxs("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [_jsx("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" }), _jsx("circle", { cx: "12", cy: "12", r: "3" }), fechado ? _jsx("line", { x1: "3", y1: "3", x2: "21", y2: "21" }) : null] }));
}
//# sourceMappingURL=CpfRevelavel.js.map